import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { NonOperationalDaysTab } from "../components/nonOperational/NonOperationalDaysTab";
import { NonOperationalPincodesTab } from "../components/nonOperational/NonOperationalPincodesTab";
import { Calendar, MapPin } from "lucide-react";

const NonOperationalDays: React.FC = () => {
	const [activeTab, setActiveTab] = useState<string>("days");

	return (
		<div className="p-6 min-h-screen bg-white dark:bg-gray-900">
			<div className="flex justify-between items-center mb-6">
				<div>
					<h1 className="text-2xl font-bold dark:text-white">
						Non Operational Management
					</h1>
					<p className="text-gray-600 dark:text-gray-400">
						Manage non-operational days and pincode stress rules
					</p>
				</div>
			</div>

			<Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
				<TabsList className="grid w-full grid-cols-2 max-w-[400px]">
					<TabsTrigger value="days" className="flex items-center gap-2">
						<Calendar className="w-4 h-4" />
						Non Operational Days
					</TabsTrigger>
					<TabsTrigger value="pincodes" className="flex items-center gap-2">
						<MapPin className="w-4 h-4" />
						Non Operational Pincodes
					</TabsTrigger>
				</TabsList>

				<TabsContent value="days" className="mt-6">
					<NonOperationalDaysTab />
				</TabsContent>

				<TabsContent value="pincodes" className="mt-6">
					<NonOperationalPincodesTab />
				</TabsContent>
			</Tabs>
		</div>
	);
};

export default NonOperationalDays;
